import { Box, Text } from 'native-base'
import React, { useState } from 'react'
import { RFPercentage } from 'react-native-responsive-fontsize'
import { useTheme } from '../../../../ThemeProvider'
import { Ionicons } from '@expo/vector-icons'
import {
  TouchableOpacity,
  Animated,
  Modal,
  Pressable,
  StyleSheet
} from 'react-native'

interface ItemMenuProps {
  onClick: (id: number) => void
  onClose: () => void
  onOpen: () => void
}

const ItemMenu: React.FC<ItemMenuProps> = ({ onClick, onClose, onOpen }) => {
  const { primaryColor, configEmpresa } = useTheme()
  const [isVisible, setIsVisible] = useState(false)
  const slideAnim = React.useRef(new Animated.Value(0)).current

  const [getConfigEmpresa, setConfigEmpresa] = useState<any>(
    JSON.parse(configEmpresa)
  )

  const showModal = () => {
    setIsVisible(true)
    onOpen()
    Animated.timing(slideAnim, {
      toValue: 1,
      duration: 300,
      useNativeDriver: true
    }).start()
  }

  const hideModal = () => {
    Animated.timing(slideAnim, {
      toValue: 0,
      duration: 300,
      useNativeDriver: true
    }).start(() => {
      setIsVisible(false)
      onClose()
    })
  }

  const translateY = slideAnim.interpolate({
    inputRange: [0, 1],
    outputRange: [300, 0]
  })

  return (
    <Box>
      <TouchableOpacity onPress={showModal}>
        <Box
          style={{
            width: 40,
            height: 40,
            borderRadius: 20,
            backgroundColor: getConfigEmpresa.coresPWA.corFundoModal || '#000',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Ionicons
            name={isVisible ? 'close' : 'menu'}
            size={24}
            color={getConfigEmpresa.coresPWA.corFontePrimaria || '#fff'}
          />
        </Box>
      </TouchableOpacity>

      <Modal
        visible={isVisible}
        transparent
        animationType='none'
        onRequestClose={hideModal}
        style={{
          backgroundColor: getConfigEmpresa.coresPWA.corFundoModal || '#000'
        }}
      >
        <Pressable style={styles.modalOverlay} onPress={hideModal}>
          <Animated.View
            style={[
              styles.modalContent,
              {
                transform: [{ translateY }],
                backgroundColor:
                  getConfigEmpresa.coresPWA.corFundoModal || '#000'
              }
            ]}
          >
            <Box
              style={[
                styles.menuContainer,
                {
                  backgroundColor:
                    getConfigEmpresa.coresPWA.corFundoModal || '#000'
                }
              ]}
            >
              <TouchableOpacity
                style={styles.menuItem}
                onPress={() => {
                  onClick(1)
                  hideModal()
                }}
              >
                <Ionicons
                  name='arrow-back-circle-sharp'
                  size={RFPercentage(3)}
                  color={getConfigEmpresa.coresPWA.corFontePrimaria || '#fff'}
                  style={styles.icon}
                />
                <Text style={styles.menuText}>Voltar</Text>
              </TouchableOpacity>

              <TouchableOpacity
                style={styles.menuItem}
                onPress={() => {
                  onClick(2)
                  hideModal()
                }}
              >
                <Ionicons
                  name='exit'
                  size={RFPercentage(3)}
                  color={getConfigEmpresa.coresPWA.corFontePrimaria || '#fff'}
                  style={styles.icon}
                />
                <Text style={styles.menuText}>Sair</Text>
              </TouchableOpacity>
            </Box>
          </Animated.View>
        </Pressable>
      </Modal>
    </Box>
  )
}

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'flex-end'
  },
  modalContent: {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    padding: 20,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: -2
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5
  },
  menuContainer: {
    paddingVertical: 10
  },
  menuItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 15,
    paddingHorizontal: 20,
    marginVertical: 5,
    borderRadius: 10,
    backgroundColor: 'rgba(0, 0, 0, 0.1)'
  },
  icon: {
    marginRight: 15
  },
  menuText: {
    fontSize: RFPercentage(2.5),
    fontWeight: 'bold'
  }
})

export default ItemMenu
